import React, { useContext, useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { DirectionContext } from '../Contexts/DirectionContext';
import { Trans, useTranslation } from 'react-i18next';
import WOW from 'wowjs';
import { contentData } from './FullBlogs';
import { useBlog } from '../Contexts/BlogContext';


export default function Blogs() {
    const {currentBlogId, setCurrentBlog } = useBlog();
  const { dir } = useContext(DirectionContext)
  const navigate = useNavigate();
  useEffect(() => {
    new WOW.WOW({
      live: true,
      mobile: false
    }).init();
  }, []);


  const handleViewFullBlog = (id) => {
    const blog = contentData.find(b => b.id === id);
    const content = contentData.find(c => c.id === id);
    setCurrentBlog(id); 
    console.log(currentBlogId)
    navigate(`/info/FullBlog/${id}`, {
      state: {
        blogData: blog,
        contentData: content
      }
    });
  };

  return <>
      <div className="container-fluid PagesLyout">
        <div className="row justify-content-center mx-3 g-4">
          <div className="col-md-11 text-center ">
            <h1 className="Title mb-3 wow fadeInLeft justify-content-center" data-wow-delay="0.3s" >
              <Trans i18nKey="BlogsTitle"> مقالات قانونية تثري معرفتك </Trans>
            </h1>
            <h3 className="pb-5  wow fadeIn" data-wow-delay="0.7s">
              <Trans i18nKey="Blogs_Subtitle">ابقَ على اطلاع بآخر المستجدات القانونية والتحليلات المتعمقة حول الأنظمة والتشريعات واللوائح، من خلال مقالاتنا المتخصصة التي يقدمها خبراؤنا القانونيون.</Trans>
            </h3>
          </div>
        </div>
        {contentData.map((blog, index) => (
          <section key={blog.id} className='pt-md-5 mt-5  wow fadeIn' data-wow-delay=".5s">
            <div className="row justify-content-center mx-3 g-4"  >
              <div className="col-lg-11">
                <div
                  className={`row g-4 align-items-center justify-content-around ${index % 2 === 1 ? "flex-md-row-reverse" : ""
                    }`}
                >
                  <div className={`col-md-6 Blogs ${blog.imageClass}`}></div>
                  <div className="col-md-6 col-lg-5">
                    <h2 className='BlogTitle'>{dir === 'ltr' ? blog.title_en : blog.title}</h2>
                    <div className="Line mt-2 mb-4"></div>
                    <div className="row g-4">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-auto">
                            <p>{dir === 'ltr' ? blog.date_en : blog.date}</p>
                          </div>
                          <div className="col-auto p-0">
                            <i className="bi bi-three-dots-vertical"></i>
                          </div>
                          <div className="col-auto">
                            <p>{dir === 'ltr' ? blog.readTime_en : blog.readTime}</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <p className="caption" style={{ color: "#4C4C4D" }}>
                          {dir === 'ltr' ? blog.brief_en : blog.brief}
                        </p>
                      </div>
                      <div className="col-md-12">
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            handleViewFullBlog(blog.id);
                          }}
                          className='ReadMoreAnchor'
                        >
                          <Trans i18nKey="ContinueReadingBtn">تابع القراءة</Trans>
                          <i
                            className={
                              dir === 'ltr'
                                ? 'fa-solid fa-chevron-right px-2'
                                : 'fa-solid fa-chevron-left px-2'
                            }
                          ></i>
                        </Link>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ))}
      </div>
  </>
}
